const PREFIX = "my-trips-login_find-by-booking-reference";
const CLICK_FIND = "click:find";
const VALIDATION = "validation";
const ERROR = "error";
export const FIND_BY_BOOKING = {
  DISPLAY: PREFIX,
  CLICK_FIND: `${PREFIX}_${CLICK_FIND}`,
  ERROR: `${PREFIX}-${ERROR}`,
  VALIDATION_ERROR: `${PREFIX}-${VALIDATION}-${ERROR}`
};